export const DEFAULT_FONT = 'Figtree';

/**
 * Allowlist of fonts an event may select for its public landing page. Keeping
 * this closed means a stored `typography.fontFamily` string can never inject an
 * arbitrary URL or family name into the page <head> or CSS.
 */
export const SUPPORTED_FONTS: Record<string, string> = {
	Figtree: 'https://fonts.googleapis.com/css2?family=Figtree:ital,wght@0,300..900;1,300..900&display=swap',
	'Bricolage Grotesque':
		'https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,200..800&display=swap',
	'Hanken Grotesk': 'https://fonts.googleapis.com/css2?family=Hanken+Grotesk:ital,wght@0,100..900;1,100..900&display=swap',
	'Plus Jakarta Sans':
		'https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap',
	Inter: 'https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap',
	Manrope: 'https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&display=swap',
	'Fraunces': 'https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,100..900;1,9..144,100..900&display=swap'
};

const FALLBACK_STACK = "ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif";

function isSupported(name?: string | null): name is string {
	return !!name && Object.prototype.hasOwnProperty.call(SUPPORTED_FONTS, name);
}

/**
 * Resolves a requested family to a CSS font-family stack, falling back to the
 * default when the request is empty or not on the allowlist.
 */
export function fontStack(name?: string | null): string {
	const family = isSupported(name) ? name : DEFAULT_FONT;
	return `'${family}', ${FALLBACK_STACK}`;
}

/**
 * Returns the Google Fonts stylesheet href for a requested family, or null when
 * it is the default (already loaded app-wide) or not allowlisted.
 */
export function googleFontHref(name?: string | null): string | null {
	if (!isSupported(name) || name === DEFAULT_FONT) return null;
	return SUPPORTED_FONTS[name];
}

export const DEFAULT_FONT_HREF = SUPPORTED_FONTS[DEFAULT_FONT];
